export const AVAILABLE_LANGUAGES = ['english', 'german', 'dutch','french','hindi','chinese','russian','japanese','italian','arabic','spanish', 'korean', 'georgian', 'portuguese', 'urdu', 'turkish', 'polish'];

export const DEFAULT_LANGUAGE ='english';